import { AppDefinition } from '../../types/apps';

export const BookkeeperAppDefinition: AppDefinition = {
  appId: 'bookkeeper',
  name: 'Bookkeeper',
  version: '2.0.0',
  description: 'AI-powered transaction categorization, P&L reports, and tax-ready bookkeeping',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Notebook',
    phosphorWeight: 'duotone',
    color: '#10b981',
  },
  entityTypes: ['BankTransaction', 'BankAccount'],
  searchableSkeletonFields: {
    BankTransaction: ['description', 'merchant_name', 'bookkeeper_category', 'tags', 'notes'],
  },
  component: 'bookkeeper',
  requiresProps: false,
  requiresEntity: false,
  experimental: true,
  hotkeys: {
    'r': 'markReviewed',
    'c': 'openCategoryDropdown',
    'b': 'toggleBusiness',
    't': 'toggleTaxDeductible',
    'Escape': 'clearSelection',
  },
};
